import { render } from "./BarChartIcon.vue?vue&type=template&id=b1232834&scoped=true"
const script = {}

import "./BarChartIcon.vue?vue&type=style&index=0&id=b1232834&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1232834"]])

export default __exports__